<header-bar></header-bar>
<div class="wrapper">
  <sidebar>
    <div class="app">
      <router-outlet></router-outlet>
    </div>
  </sidebar>
</div>

